import axios from "axios";

export const csrf_protection = () => dispatch => {
    // https://laravel.com/docs/8.x/sanctum#csrf-protection
    axios.get('./sanctum/csrf-cookie');
};

export const clear_change_password_status = () => dispatch => {
    dispatch({
        type: "CLEAR_CHANGE_PASSWORD_STATUS"
    });
}

export const change_password = (old_password, new_password, new_password_confirmation, recaptcha_token) => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/change-password",
            JSON.stringify({old_password, new_password, new_password_confirmation, recaptcha_token}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        dispatch({
            type: "SET_CHANGE_PASSWORD_STATUS",
            status: "success",
            message: res.data.success,
            errors: [],
        });
    })
        .catch(err => {
            dispatch({
                type: "SET_CHANGE_PASSWORD_STATUS",
                status: "error",
                message: err.response.data.error,
                errors: err.response.data.errors,
            });
        });
};

export const clear_forgot_password_status = () => dispatch => {
    dispatch({
        type: "CLEAR_FORGOT_PASSWORD_STATUS"
    });
}

export const clear_register_success = () => dispatch => {
    dispatch({
        type: "CLEAR_REGISTER_SUCCESS"
    });
}

export const forgot_password = (email, recaptcha_token) => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/forgot-password",
            JSON.stringify({email, recaptcha_token}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        dispatch({
            type: "SET_FORGOT_PASSWORD_STATUS",
            status: "success",
            message: res.data.success,
            errors: [],
        });
    })
        .catch(err => {
            dispatch({
                type: "SET_FORGOT_PASSWORD_STATUS",
                status: "error",
                message: err.response.data.error,
                errors: err.response.data.errors,
            });
        });
};
export const refresh_ai_availability = () => dispatch => {
    axios
        .get(
            "/api/ai/availability",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        dispatch({
            type: "SET_AI_AVAILABILITY",
            availability: res.data.ai_available
        });
    })
        .catch(err => {
        });
};
export const refresh_voice_availability = () => dispatch => {
    axios
        .get(
            "/api/listen/availability",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        dispatch({
            type: "SET_VOICE_AVAILABILITY",
            availability: res.data.voice_available
        });
    })
        .catch(err => {
        });
};

export const reset_password = (email, token, new_password, new_password_confirmation, recaptcha_token) => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/reset-password",
            JSON.stringify({email, token, new_password, new_password_confirmation, recaptcha_token}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        dispatch({
            type: "SET_PASSWORD_CHANGE_STATUS",
            status: "success",
            message: res.data.success,
            errors: [],
        });
    })
        .catch(err => {
            dispatch({
                type: "SET_PASSWORD_CHANGE_STATUS",
                status: "error",
                message: err.response.data.error,
                errors: err.response.data.errors,
            });
        });
};
/*
export const auth_with_facebook = (access_token) => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/facebook",
            JSON.stringify({access_token}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        if (res.data.token) {
            dispatch({
                type: "LOGIN",
                data: res.data
            });
        } else {
            dispatch({
                type: "LOGIN_ERROR",
                errors: res.data
            });
        }
    })
        .catch(err => {
            if (err.response.status === 400) {
                dispatch({
                    type: "LOGIN_ERROR",
                    errors: err.response.data
                });
            } else {
                dispatch({
                    type: "LOGIN_ERROR",
                    errors: {
                        "server_error": ["Error, try it again later."]
                    }
                });
            }
        });
};*/

export const auth_with_google = (id_token) => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/google",
            JSON.stringify({id_token}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        if (res.data.token) {
            dispatch({
                type: "LOGIN",
                data: res.data
            });
        } else {
            dispatch({
                type: "LOGIN_ERROR",
                errors: res.data
            });
        }
    })
        .catch(err => {
            if (err.response.status === 400) {
                dispatch({
                    type: "LOGIN_ERROR",
                    errors: err.response.data
                });
            } else {
                dispatch({
                    type: "LOGIN_ERROR",
                    errors: {
                        "server_error": ["Error, try it again later."]
                    }
                });
            }
        });
};

export const register = (firstName, lastName, email, password, recaptchaToken) => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/register",
            JSON.stringify({
                first_name: firstName,
                last_name: lastName,
                email,
                password,
                recaptcha_token: recaptchaToken
            }),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "REGISTER_SUCCESS",
                success: res.data.success,
            });
            return true;
        })
        .catch(err => {
            if (err.response.status.toString().startsWith('4')) {
                dispatch({
                    type: "REGISTER_ERROR",
                    errors: err.response.data.errors
                });
            } else {
                dispatch({
                    type: "REGISTER_ERROR",
                    errors: {
                        "server_error": ["Server error, please try it again later."]
                    }
                });
            }
            return false;
        })
}

export const login = (email, password) => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/login",
            JSON.stringify({email, password, device_name: navigator.userAgent}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
        if (res.data.token) {
            dispatch({
                type: "LOGIN",
                data: res.data
            });
        } else {
            dispatch({
                type: "LOGIN_ERROR",
                errors: res.data
            });
        }
    })
        .catch(err => {
            if (err.response.status.toString().startsWith('4')) {
                dispatch({
                    type: "LOGIN_ERROR",
                    errors: {
                        "server_error": ["Incorrect credentials"]
                    }
                })
            } else {
                dispatch({
                    type: "LOGIN_ERROR",
                    errors: {
                        "server_error": ["Server error, please try it again later."]
                    }
                });
            }
        });
};

export const logout = () => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .post(
            "/api/user/logout",
            "",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "LOGOUT"
            });
        })
        .catch(err => {
            dispatch({
                type: "LOGOUT"
            });
        });
};

export const get_user_info = () => dispatch => {
    dispatch({type: "SET_WAITING"});
    axios
        .get(
            "/api/user",
            "",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            if (res.data) {
                dispatch({
                    type: "SET_USER_INFO",
                    user_info: res.data
                });
            }
        })
        .catch(err => {
            dispatch({
                type: "LOGOUT"
            });
        });
};

export const clear_login_error = () => dispatch => {
    dispatch({
        type: "CLEAR_LOGIN_ERROR"
    });
};

export const clear_password_change_status = () => dispatch => {

    dispatch({
        type: "CLEAR_PASSWORD_CHANGE_STATUS"
    });
};

export const clear_register_error = () => dispatch => {
    dispatch({
        type: "CLEAR_REGISTER_ERROR"
    });
};

export const clear_auth_messages = () => dispatch => {
    dispatch({
        type: "CLEAR_AUTH_MESSAGES"
    });
}

export const set_auth_errors = (error_key, error_text) => dispatch => {

    dispatch({
        type: "LOGIN_ERROR",
        errors: {
            error_key: [error_text]
        }
    });
}

export const remove_account = (password) => dispatch => {
    return axios
        .post(
            "/api/user/remove-account",
            JSON.stringify({password}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};
